/**
 * CloudInsurance stores the country as an ISO 3166-1 alpha-2 code, so the raw
 * value is `CH` and not `Schweiz`. These are the codes the portal expects; the
 * list is short on purpose, because the policies are sold in this region only.
 */
const COUNTRY_NAME_KEYS: Record<string, string> = {
  AT: 'common.country.at',
  CH: 'common.country.ch',
  DE: 'common.country.de',
  FR: 'common.country.fr',
  IT: 'common.country.it',
  LI: 'common.country.li',
};

/** The code used when the profile carries no country. */
export const DEFAULT_COUNTRY_CODE = 'CH';

/**
 * Gives the translation key for a country code. An unknown code has no key, so
 * the caller shows the raw value instead of an empty field.
 */
export function countryNameKey(code?: string): string | undefined {
  if (!code) {
    return COUNTRY_NAME_KEYS[DEFAULT_COUNTRY_CODE];
  }

  return COUNTRY_NAME_KEYS[code.trim().toUpperCase()];
}
